import React, { useEffect, useState } from "react";
import { Dropdown, Checkbox, Button, Tooltip, Divider } from "antd";
import { CustomTitle } from "../../../components";
import { truncateParagraph } from "../../../common/helper";

const HomeMapMultiSelectDropdown = ({
  triggerButton,
  options,
  title,
  selectedIds = [],
  onApply,
  showColors = false,
  getColor = () => "#000",
  dropdownWidth = 240,
}) => {
  
  const [selectedItems, setSelectedItems] = useState(selectedIds);
  const [open, setOpen] = useState(false);

  const isAllSelected = selectedItems.length === options.length;

  const handleSelectAll = (checked) => {
    setSelectedItems(checked ? options.map((o) => o.id) : []);
  };

    // Sync selectedIds to selectedItems when dropdown opens
    useEffect(() => {
      if (open) {
        setSelectedItems(selectedIds);
      }
    }, [open, selectedIds]);

  const handleCheckboxChange = (checked, id) => {
    setSelectedItems((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleReset = () => {
    setSelectedItems([]);
    onApply([]);
    setOpen(false);
  };

  const handleApply = () => {
    onApply(selectedItems);
    setOpen(false);
  };

  const renderOption = (option) => (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Tooltip title={option?.title || option?.name}>
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {truncateParagraph(option?.title || option?.name, 15)}{" "}
          <span style={{ color: "#5E5E5E" }}>
            {" "}
            {option?.name2 ? `${option?.name2}` : ""}
          </span>
        </span>
      </Tooltip>
      {showColors && (
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: getColor(option),
            marginLeft: 8,
          }}
        />
      )}
    </span>
  );

  const content = (
    <div
      style={{
        backgroundColor: "#fff",
        width: dropdownWidth,
        borderRadius: 8,
        boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
        padding: "12px 16px 8px 16px",
      }}
    >
      <CustomTitle
        text={title}
        fontSize={12}
        fontWeight={600}
        lineHeight="16px"
        color="#5e5e5e"
        marginBottom="12px"
        marginTop={0}
      />
      {options.length > 0 ? (
        <>
          {/* <Checkbox
            checked={isAllSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            style={{ marginBottom: 8 }}
          >
            Select All
          </Checkbox> */}
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            {options.map((option) => (
              <div
                key={option.id}
                className="for-dropdown-colors"
                style={{ padding: "6px 0" }}
              >
                <Checkbox
                  checked={selectedItems.includes(option.id)}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, option.id)
                  }
                  style={{ width: "100%" }}
                >
                  {renderOption(option)}
                </Checkbox>
              </div>
            ))}
          </div>
        </>
      ) : (
        <p style={{ color: "#999", textAlign: "center" }}>No data</p>
      )}
      <Divider style={{ margin: "10px 0" }} />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 12,
          gap: 8,
        }}
      >
        <Button
          type="text"
          disabled={selectedItems.length === 0 && selectedIds.length === 0}
          onClick={handleReset}
          style={{ fontSize: 12, height: 28, width: "52px", fontWeight: 600 }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          disabled={selectedItems.length === 0 && selectedIds.length === 0}
          onClick={handleApply}
          style={{
            fontWeight: 600,
            height: 28,
            width: "52px",
            fontSize: 12,
            borderRadius: "8px",
            backgroundColor: selectedItems.length === 0 && selectedIds.length === 0 ? "#ccc" : "#000",
            borderColor: selectedItems.length === 0 && selectedIds.length === 0 ? "#ccc" : "#000",
          }}
        >
          Apply
        </Button>
      </div>
    </div>
  );

  return (
    <Dropdown
      overlay={content}
      trigger={["click"]}
      open={open}
      onOpenChange={setOpen}
      placement="bottomLeft"
      overlayStyle={{ zIndex: 100 }}
    >
      <div onClick={() => setOpen(!open)}>{triggerButton}</div>
    </Dropdown>
  );
};

export default HomeMapMultiSelectDropdown;
